import { getInterface } from '@/utils/js/initVariable';
const prefixUrl = 'api/FootPrintMapApi/';
export const queryMapViewList = (data)=>{
  return getInterface.post(`${prefixUrl}queryMapViewList`, data);
}
export const putMap = (data)=>{
  return getInterface.post(`${prefixUrl}putMap`, data);
}
export const queryPageList = (data)=>{
  console.log("data",data)
  return getInterface.post(`${prefixUrl}queryPageList`, data);
}
export const deleteMap = (data)=>{
  return getInterface.post(`${prefixUrl}deleteMap/${data}`, data);
}
export const getMapBoxPlaces = (data)=>{
  return getInterface.post(`${prefixUrl}getMapBoxPlaces`, data);
}
export const queryExposureProperties = (data)=>{
  return getInterface.post(`${prefixUrl}queryExposureProperties`, data);
}
// 编辑区域内OSM
export const getMapBoxPlacesGeometry = (data)=>{
  return getInterface.post(`${prefixUrl}getMapBoxPlacesGeometry`, data);
}
// 底图图层信息
export const queryFeatureInfo = (data)=>{
  return getInterface.post(`${prefixUrl}queryFeatureInfo`, data);
}
// 底图分配用户
export const geoserverMapToUser = (data)=>{
  return getInterface.post(`${prefixUrl}geoserverMapToUser`, data);
}
// 新 底图port
export const getPermissionPng = ()=>{
  return `${prefixUrl}getPermissionPng`;
}
// 底图List
export const queryFootPrintMapList = (data)=>{
  return getInterface.post(`${prefixUrl}queryFootPrintMapList`, data);
}
// 底图权限预览
export const queryFootPrintMapAllocateList = (data)=>{
  return getInterface.post(`${prefixUrl}queryFootPrintMapAllocateList`, data);
}
// 底图权限预览 - 删除
export const modifyAllocateList = (data)=>{
  return getInterface.post(`${prefixUrl}modifyAllocateList`, data);
}
// 工作台底图List
export const queryAllTypeMapList = (data)=>{
  return getInterface.post(`${prefixUrl}queryAllTypeMapList`, data);
}